import ContractsPage from "./ContractsPage";

export default ContractsPage;
